import { ErrorBoundary } from 'react-error-boundary';

import { reportError } from 'utils/errorBoundary';

const AppBoundary = ({ children }: { children: React.ReactNode }) => (
  <ErrorBoundary
    onError={(err) => {
      reportError(`${err.message}:`, err);
    }}
    fallbackRender={() => null}
  >
    {children}
  </ErrorBoundary>
);

export default AppBoundary;
